"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderContainer = exports.HeaderSubtitle = exports.HeaderTitle = exports.ContextMenuSwitchWrapper = exports.ContextMenuContainer = exports.ContextMenuLink = exports.ContextMenuSwitchContainer = exports.StyledGridContainer = exports.SelectorsWrapper = exports.StyledMatrixContainer = exports.NoDataWrapper = exports.HeaderCell = exports.CellWrapper = exports.StyledGrid = void 0;
const ui_components_1 = require("@groupby/ui-components");
const react_router_dom_1 = require("react-router-dom");
const react_window_1 = require("react-window");
const styled_components_1 = __importDefault(require("styled-components"));
const generic_1 = require("../../../generic");
const PAGE_TITLE = '7vh';
const FILTER_SECTION = '18vh';
const CONTEXT_MENU_Z_INDEX = 15;
exports.StyledGrid = (0, styled_components_1.default)(react_window_1.FixedSizeGrid) `
  border-collapse: collapse;
  width: 100%;
`;
exports.CellWrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: ${({ $isFirstColumn }) => ($isFirstColumn ? 'left' : 'right')};
  border: 0.5px solid ${ui_components_1.baseColors.gray200};
  padding: ${({ theme }) => theme.spacing(1)};
  text-align: ${({ $isFirstColumn }) => ($isFirstColumn ? 'left' : 'right')};
  box-sizing: border-box;
  background-color: ${({ $isTotalsRow }) => ($isTotalsRow ? '#fff' : `${ui_components_1.baseColors.background000}`)};
  font-weight: ${({ $isTotalsRow }) => ($isTotalsRow ? 'bold' : 'normal')};
  color: ${({ $isTotalsRow }) => !$isTotalsRow && `${ui_components_1.baseColors.background600}`};

  &:hover {
    background-color: ${ui_components_1.baseColors.primaryTeal100};
  }
`;
exports.HeaderCell = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0.5px solid ${ui_components_1.baseColors.gray200};
  padding: ${({ theme }) => theme.spacing(1)};
  text-align: center;
  box-sizing: border-box;
  background-color: ${ui_components_1.baseColors.primaryBlue100};
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px;
`;
exports.NoDataWrapper = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  & > svg {
    width: 127px;
    height: 121px;
  }
`;
exports.StyledMatrixContainer = (0, styled_components_1.default)(generic_1.StyledPageContainer) `
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => theme.spacing(0, 1)};
`;
exports.SelectorsWrapper = styled_components_1.default.div `
  display: flex;
  background: ${ui_components_1.baseColors.white};
  padding: ${({ theme }) => theme.spacing(1, 1.5)};

  & > div > button.MuiButton-textPrimary {
    color: ${ui_components_1.baseColors.background600};
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
  }
`;
exports.StyledGridContainer = styled_components_1.default.div `
  height: calc(100vh - ${PAGE_TITLE} - ${FILTER_SECTION});
  max-width: 100%;
  display: flex;
  flex-direction: column;

  && {
    .ag-cell {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      border: 1px solid ${ui_components_1.baseColors.gray200};
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      background: ${ui_components_1.baseColors.white};
      padding: ${({ theme }) => theme.spacing(0.625)};
    }

    .ag-pinned-left-cols-container .ag-cell {
      justify-content: flex-start;
      align-items: flex-start;
      white-space: normal !important;
      word-break: break-word;
      overflow: visible !important;
      /* lift the cell above sibling rows so overflowed text isn't hidden */
      position: relative;
      z-index: 1;
    }
 
    .ag-pinned-left-cols-container {
      overflow: visible !important;
    }

    .ag-header-cell {
      border: 1px solid ${ui_components_1.baseColors.gray200};
      font-size: 12px;
      font-weight: 700;
      line-height: 16px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      background: ${ui_components_1.baseColors.white};
      padding: ${({ theme }) => theme.spacing(0.625)};
    }

    .ag-pinned-left-header .ag-header-cell {
      justify-content: flex-start;
    }
 
    .ag-header-cell:not(.ag-column-resizing):not(.ag-column-hover):not(.ag-header-cell-moving):hover {
      background-color: ${ui_components_1.baseColors.white};
    }

    .ag-header-cell .ag-header-active {
      background-color: ${ui_components_1.baseColors.white};
    }

    .ag-cell[col-id="totalProductCount"] {
      background-color: ${ui_components_1.baseColors.primaryBlue100};
      font-weight: bold;
    }

    .ag-row {
      border-bottom: 0;
    }

    .ag-row-pinned {
      background-color: ${ui_components_1.baseColors.primaryBlue100};
      font-weight: bold;
    }

    .ag-floating-bottom {
      border: 0;
      font-size: 14px;
      font-weight: 400;
      line-height: 16px;
      background-color: ${ui_components_1.baseColors.primaryBlue100} ;
    }
    .ag-floating-bottom-container {
      .ag-cell {
        background-color: ${ui_components_1.baseColors.primaryBlue100} ;
        pointer-events: none;
      }
    }

    .ag-pinned-left-floating-bottom {
      font-size: 12px;
      font-weight: 600;
      line-height: 20px;
    }

    .ag-horizontal-left-spacer {
      overflow: hidden;
    }

    .ag-root-wrapper {
      border: 0;
    }

    .mapped-cell {
      background-color: ${ui_components_1.baseColors.white}; 
    }

    .unmapped-cell {
      background-color: ${ui_components_1.baseColors.gray200}; 
      border: 0.5px solid ${ui_components_1.baseColors.gray300}; 
    }
  }
`;
exports.ContextMenuSwitchContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
`;
exports.ContextMenuLink = (0, styled_components_1.default)(react_router_dom_1.Link) `
  margin-top: 8px;
  display: block;
  text-decoration: none;
  color: inherit;
`;
exports.ContextMenuContainer = styled_components_1.default.div `
  position: fixed;
  top: ${({ y }) => y}px;
  left: ${({ x }) => x}px;
  background: ${ui_components_1.baseColors.white};
  border: 1px solid gray;
  z-index: ${CONTEXT_MENU_Z_INDEX};
  padding: ${({ theme }) => theme.spacing(0.5)};
`;
exports.ContextMenuSwitchWrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
`;
exports.HeaderTitle = styled_components_1.default.div `
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 140px;
`;
exports.HeaderSubtitle = styled_components_1.default.div `
  font-size: 12px;
  font-style: italic;
  font-weight: 400;
  line-height: 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 140px; 
`;
exports.HeaderContainer = styled_components_1.default.div `
  padding: ${({ theme }) => theme.spacing(0, 2)};
`;
